/** Supported types of review author. */
export var AuthorType;
(function (AuthorType) {
    AuthorType["UNKNOWN"] = "UNKNOWN";
    AuthorType["MEMBER"] = "MEMBER";
    AuthorType["VISITOR"] = "VISITOR";
})(AuthorType || (AuthorType = {}));
/** Supported states of the review. */
export var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus["UNKNOWN"] = "UNKNOWN";
    ModerationStatus["APPROVED"] = "APPROVED";
    ModerationStatus["IN_MODERATION"] = "IN_MODERATION";
    ModerationStatus["REJECTED"] = "REJECTED";
    ModerationStatus["SUBMITTED"] = "SUBMITTED";
})(ModerationStatus || (ModerationStatus = {}));
/** Supported types of review origin. */
export var OriginType;
(function (OriginType) {
    /** Indicates that the review origin is unknown. */
    OriginType["UNKNOWN"] = "UNKNOWN";
    /** Indicates that the review was created organically. */
    OriginType["ORGANIC"] = "ORGANIC";
    /** Indicates that the review was created by an application. */
    OriginType["APP"] = "APP";
})(OriginType || (OriginType = {}));
export var SourceType;
(function (SourceType) {
    /** Indicates that the source type is unknown. */
    SourceType["UNKNOWN_SOURCE_TYPE"] = "UNKNOWN_SOURCE_TYPE";
    /** Indicates that the review was created from a review request. */
    SourceType["REVIEW_REQUEST"] = "REVIEW_REQUEST";
    /** Indicates that the review was created from a request link. */
    SourceType["REQUEST_LINK"] = "REQUEST_LINK";
})(SourceType || (SourceType = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["UPVOTE"] = "UPVOTE";
    Type["DOWNVOTE"] = "DOWNVOTE";
})(Type || (Type = {}));
export var VoterType;
(function (VoterType) {
    VoterType["UNKNOWN"] = "UNKNOWN";
    VoterType["MEMBER"] = "MEMBER";
    VoterType["VISITOR"] = "VISITOR";
})(VoterType || (VoterType = {}));
export var Fieldset;
(function (Fieldset) {
    Fieldset["UNKNOWN_FIELDSET"] = "UNKNOWN_FIELDSET";
    Fieldset["CURRENT_USER_REVIEW"] = "CURRENT_USER_REVIEW";
    Fieldset["CURRENT_MEMBER"] = "CURRENT_MEMBER";
    Fieldset["CURRENT_USER_PERMISSIONS"] = "CURRENT_USER_PERMISSIONS";
    Fieldset["OVERALL_RATING_SUMMARY"] = "OVERALL_RATING_SUMMARY";
    Fieldset["CONFIGURATION"] = "CONFIGURATION";
    Fieldset["MEMBER_NAMES"] = "MEMBER_NAMES";
    Fieldset["CURRENT_USER_VOTES"] = "CURRENT_USER_VOTES";
    Fieldset["REVIEW_REQUEST_RECIPIENT_REVIEW"] = "REVIEW_REQUEST_RECIPIENT_REVIEW";
})(Fieldset || (Fieldset = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    Status["PENDING"] = "PENDING";
    Status["APPROVED"] = "APPROVED";
    Status["BLOCKED"] = "BLOCKED";
    Status["OFFLINE"] = "OFFLINE";
})(Status || (Status = {}));
export var PrivacyStatusStatus;
(function (PrivacyStatusStatus) {
    PrivacyStatusStatus["UNKNOWN"] = "UNKNOWN";
    PrivacyStatusStatus["PRIVATE"] = "PRIVATE";
    PrivacyStatusStatus["PUBLIC"] = "PUBLIC";
})(PrivacyStatusStatus || (PrivacyStatusStatus = {}));
export var ActivityStatusStatus;
(function (ActivityStatusStatus) {
    ActivityStatusStatus["UNKNOWN"] = "UNKNOWN";
    ActivityStatusStatus["ACTIVE"] = "ACTIVE";
    ActivityStatusStatus["MUTED"] = "MUTED";
})(ActivityStatusStatus || (ActivityStatusStatus = {}));
export var Permission;
(function (Permission) {
    Permission["UNKNOWN_PERMISSION"] = "UNKNOWN_PERMISSION";
    Permission["CREATE_REVIEW"] = "CREATE_REVIEW";
    Permission["UPDATE_REVIEW"] = "UPDATE_REVIEW";
    Permission["DELETE_REVIEW"] = "DELETE_REVIEW";
    Permission["SET_REPLY"] = "SET_REPLY";
    Permission["REMOVE_REPLY"] = "REMOVE_REPLY";
    Permission["VOTE"] = "VOTE";
})(Permission || (Permission = {}));
export var ReviewsSorting;
(function (ReviewsSorting) {
    ReviewsSorting["UNKNOWN_REVIEWS_SORTING"] = "UNKNOWN_REVIEWS_SORTING";
    ReviewsSorting["NEWEST"] = "NEWEST";
    ReviewsSorting["OLDEST"] = "OLDEST";
    ReviewsSorting["HELPFUL"] = "HELPFUL";
    ReviewsSorting["HIGHEST_RATED"] = "HIGHEST_RATED";
    ReviewsSorting["LOWEST_RATED"] = "LOWEST_RATED";
    ReviewsSorting["MOST_RELEVANT"] = "MOST_RELEVANT";
})(ReviewsSorting || (ReviewsSorting = {}));
//# sourceMappingURL=types.impl.js.map